'use strict';

/**
 * Reads Meta tracking configuration from the DOM.
 * @returns {Object|null} config
 */
function getConfig() {
    var $node = $('.meta-capi').first();
    if (!$node.length) {
        return null;
    }

    return {
        url: $node.data('url'),
        tokenName: $node.data('tokenname'),
        token: $node.data('token')
    };
}

/**
 * Generates a best-effort unique event id.
 * @returns {string} eventId
 */
function uuid() {
    // Lightweight UUID-ish for event_id (Meta accepts any string)
    return 'evt_' + Math.random().toString(16).slice(2) + '_' + Date.now();
}

/**
 * Posts a tracking payload to the internal Meta endpoint.
 * @param {Object} config - Meta config (url + csrf)
 * @param {Object} payload - Payload fields
 * @returns {void}
 */
function post(config, payload) {
    if (!config || !config.url || !config.tokenName || !config.token) {
        return;
    }

    var data = {};
    data[config.tokenName] = config.token;
    Object.keys(payload).forEach(function (k) {
        data[k] = payload[k];
    });

    $.ajax({
        url: config.url,
        method: 'POST',
        data: data
    });
}

module.exports = {
    /**
     * Tracks a Meta CAPI event via the internal proxy endpoint.
     * @param {string} eventName - Meta event name
     * @param {Object} customData - Meta custom_data
     * @param {string} [eventId] - Optional event_id
     * @returns {void}
     */
    track: function (eventName, customData, eventId) {
        if (!eventName) {
            return;
        }

        var config = getConfig();
        post(config, {
            eventName: eventName,
            eventId: eventId || uuid(),
            eventSourceUrl: window.location.href,
            customData: JSON.stringify(customData || {})
        });
    }
};
